export const PORT_TYPES_FOR_SCAN = {
  POPULAR: "POPULAR",
  HIDDEN: "HIDDEN",
  PROXY: "PROXY"
}
